export interface FormatOptions {
  defaultValue?: string;
  full?: boolean;
}

// Accepte les champs nullables (ex. OutgoingContact/SalePatient) autant que User/Contact : le corps
// gère déjà `== null` (null comme undefined).
export const formatUserName = (
  contact: { email?: string | null; firstName?: string | null; lastName?: string | null } | null | undefined,
  { defaultValue = "Inconnu", full = true }: FormatOptions = {},
): string => {
  if (contact == null) {
    return defaultValue;
  }
  if (contact.lastName == null) {
    return contact.firstName?.trim() ?? contact.email ?? defaultValue;
  }

  const lastName = (full ? contact.lastName : `${contact.lastName.slice(0, 1)}.`).toUpperCase();

  if (contact.firstName == null) {
    return lastName.trim();
  }
  return full ? `${lastName.trim()} ${contact.firstName.trim()}` : `${contact.firstName.trim()} ${lastName.trim()}`;
};
